export enum ReportImageType {
  "damage" = "damage",
  "damageDetail" = "damageDetail",
  "plate" = "plate",
  "cockpit" = "cockpit",
  "overview" = "overview",
  "registration" = "registration",
  "registrationBack" = "registrationBack",
  "others" = "others",
  "vin" = "vin",
  "tuev" = "tuev",
  "tire" = "tire",
  "wheel" = "wheel",
  "wheelDetail" = "wheelDetail",
  "driverslicensefront" = "driverslicensefront",
  "driverslicenseback" = "driverslicenseback",
  "scene" = "scene",
  "glass" = "glass",

  /**
   * Old damage, that are already submitted
   */
  preExisting = "preExisting",

  /**
   * Completion or post repair images.
   */
  completion = "completion"
}
